import { render, staticRenderFns } from "./TextColumn.vue?vue&type=template&id=67b44599&scoped=true&"
import script from "./TextColumn.vue?vue&type=script&lang=js&"
export * from "./TextColumn.vue?vue&type=script&lang=js&"
import style0 from "./TextColumn.vue?vue&type=style&index=0&id=67b44599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b44599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b44599')) {
      api.createRecord('67b44599', component.options)
    } else {
      api.reload('67b44599', component.options)
    }
    module.hot.accept("./TextColumn.vue?vue&type=template&id=67b44599&scoped=true&", function () {
      api.rerender('67b44599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/column/TextColumn.vue"
export default component.exports